var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaymentInactive = function SvgPaymentInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "24px",
    viewBox: "0 0 30 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "06.-Health-Screens\\uD83D\\uDC8A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "201_Appointments",
    transform: "translate(-410.000000, -654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(259.998000, 507.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    transform: "translate(0.002000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-Copy",
    transform: "translate(0.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cell-copy",
    transform: "translate(150.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Components-/-Status-/-Payment",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,0.5 C27.6903559,0.5 28.3153559,0.779822031 28.767767,1.23223305 C29.220178,1.68464406 29.5,2.30964406 29.5,3 L29.5,3 L29.5,21 C29.5,21.6903559 29.220178,22.3153559 28.767767,22.767767 C28.3153559,23.220178 27.6903559,23.5 27,23.5 L27,23.5 L3,23.5 C2.30964406,23.5 1.68464406,23.220178 1.23223305,22.767767 C0.779822031,22.3153559 0.5,21.6903559 0.5,21 L0.5,21 L0.5,3 C0.5,2.30964406 0.779822031,1.68464406 1.23223305,1.23223305 C1.68464406,0.779822031 2.30964406,0.5 3,0.5 L3,0.5 Z",
    id: "Rectangle",
    stroke: "#CACFD3",
    fillOpacity: 0.05,
    fill: "#8F9BA9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Line-/-Payment",
    transform: "translate(5.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8333333,4.16666667 C17.6617605,4.16666667 18.3333333,4.83823954 18.3333333,5.66666667 L18.3333333,15.1666667 C18.3333333,15.9950938 17.6617605,16.6666667 16.8333333,16.6666667 L3.16666667,16.6666667 C2.33823954,16.6666667 1.66666667,15.9950938 1.66666667,15.1666667 L1.66666667,5.66666667 C1.66666667,4.83823954 2.33823954,4.16666667 3.16666667,4.16666667 L16.8333333,4.16666667 Z M17.0833333,9.16666667 L2.91666667,9.16666667 L2.91666667,15.4166667 L17.0833333,15.4166667 L17.0833333,9.16666667 Z M13.5416667,11.25 C13.9154479,11.25 14.250911,11.4140592 14.4799756,11.6740973 C14.2843509,11.8943371 14.1666667,12.1834253 14.1666667,12.5 C14.1666667,12.8165747 14.2843509,13.1056629 14.4783577,13.3259027 C14.250911,13.5859408 13.9154479,13.75 13.5416667,13.75 C12.8513107,13.75 12.2916667,13.1903559 12.2916667,12.5 C12.2916667,11.8096441 12.8513107,11.25 13.5416667,11.25 Z M15.4166667,11.25 C16.1070226,11.25 16.6666667,11.8096441 16.6666667,12.5 C16.6666667,13.1903559 16.1070226,13.75 15.4166667,13.75 C15.0428855,13.75 14.7074224,13.5859408 14.4783577,13.3259027 C14.6739824,13.1056629 14.7916667,12.8165747 14.7916667,12.5 C14.7916667,12.1834253 14.6739824,11.8943371 14.4799756,11.6740973 C14.7074224,11.4140592 15.0428855,11.25 15.4166667,11.25 Z M6.9503012,12.2916667 C7.13882028,12.2916667 7.29166667,12.4782292 7.29166667,12.7083333 C7.29166667,12.9384375 7.13882028,13.125 6.9503012,13.125 L4.09136546,13.125 C3.90284639,13.125 3.75,12.9384375 3.75,12.7083333 C3.75,12.4782292 3.90284639,12.2916667 4.09136546,12.2916667 L6.9503012,12.2916667 Z M6.9503012,10.8333333 C7.13882028,10.8333333 7.29166667,11.0198958 7.29166667,11.25 C7.29166667,11.4801042 7.13882028,11.6666667 6.9503012,11.6666667 L4.09136546,11.6666667 C3.90284639,11.6666667 3.75,11.4801042 3.75,11.25 C3.75,11.0198958 3.90284639,10.8333333 4.09136546,10.8333333 L6.9503012,10.8333333 Z M17.0833333,5.41666667 L2.91666667,5.41666667 L2.91666667,6.66666667 L17.0833333,6.66666667 L17.0833333,5.41666667 Z",
    id: "Combined-Shape",
    fill: "#CACFD3"
  }))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment-inactive.2140282a.svg";
export { ForwardRef as ReactComponent };